import axios from 'axios';
import {
    getRequest,
    getSuccess,
    getFailed,
    getError,
    createRequest,
    createSuccess,
    createFailed,
    createError,
    deleteRequest,
    deleteSuccess,
    deleteFailed,
    deleteError
} from './complainSlice';


/**
 * Safely extracts a serializable error message from an error object.
 * This prevents non-serializable values (like AxiosError) from being stored in Redux state.
 * @param {any} error - The error object (typically from axios)
 * @returns {string} - A serializable error message
 */
const extractErrorMessage = (error) => {
    if (!error) return 'An unknown error occurred';
    if (typeof error === 'string') return error;
    
    // Handle axios errors
    if (error.response?.data?.error) return error.response.data.error;
    if (error.response?.data?.message) return error.response.data.message;
    if (error.response?.statusText) return error.response.statusText;
    if (error.response?.status) return `Server error (${error.response.status})`;
    
    // Handle network errors
    if (error.code === 'ECONNABORTED') return 'Request timed out. Please try again.';
    if (error.code === 'ERR_NETWORK') return 'Unable to connect to server. Please check your connection.';
    
    // Fallback to message or generic error
    if (error.message) return error.message;
    
    return 'An unknown error occurred';
};

export const getAllComplains = (id, address) => async (dispatch) => {
    dispatch(getRequest());

    try {
        const result = await axios.get(`${process.env.REACT_APP_BASE_URL}/${address}List/${id}`);
        if (result.data.message) {
            dispatch(getFailed(result.data.message));
        } else {
            dispatch(getSuccess(result.data));
        }
    } catch (error) {
        dispatch(getError(extractErrorMessage(error)));
    }
}

export const createComplain = (fields) => async (dispatch) => {
    dispatch(createRequest());

    try {
        const result = await axios.post(`${process.env.REACT_APP_BASE_URL}/ComplainCreate`, fields, {
            headers: { 'Content-Type': 'application/json' },
        });
        dispatch(createSuccess());
    } catch (error) {
        if (error.response?.data?.message) {
            dispatch(createFailed(error.response.data.message));
        } else {
            dispatch(createError(extractErrorMessage(error)));
        }
    }
}

export const deleteComplain = (schoolId, complainId) => async (dispatch) => {
    dispatch(deleteRequest());
    try {
        const result = await axios.delete(`${process.env.REACT_APP_BASE_URL}/Complains/${schoolId}`, {
            data: { ids: [complainId] }
        });
        dispatch(deleteSuccess());
        dispatch(getAllComplains(schoolId, "Complain")); // Refresh list
    } catch (error) {
        dispatch(deleteError(extractErrorMessage(error)));
    }
};

export const deleteComplains = (schoolId, ids) => async (dispatch) => {
    dispatch(deleteRequest());
    try {
        const result = await axios.delete(`${process.env.REACT_APP_BASE_URL}/Complains/${schoolId}`, {
            data: { ids }
        });
        dispatch(deleteSuccess());
        dispatch(getAllComplains(schoolId, "Complain")); // Refresh list
    } catch (error) {
        dispatch(deleteError(extractErrorMessage(error)));
    }
};

